
import { Base } from '../base-component';
import './infographic-page.component.scss';

export class InfographicPage extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}
}


// WEBPACK FOOTER //
// ./components/infographic-page/infographic-page.component.ts